import { Component, inject } from '@angular/core'

import { MarkdownComponent, TypographyComponent } from '@hyperkit'

import { QueryViewService } from '../../../../../services/reader/query-view.service'

@Component({
  standalone: true,
  selector: 'query-selected-deployment-requirements-tab',
  imports: [TypographyComponent, MarkdownComponent],
  templateUrl: './deployment-requirements-tab.component.html',
  styleUrls: ['./deployment-requirements-tab.component.scss'],
})
export class DeploymentRequirementsTabComponent {
  private readonly queryView = inject(QueryViewService)
  /** The currently selected query/pivot node */
  readonly selectedQuery = this.queryView.selectedQuery
}
